export default __webpack_public_path__ + "static/media/theme_luxus.9a67d17e.jpg";